import type { HelpFile } from '../../types/help'
import { AccountStatusEventsTimelineTestIds } from '../../../testids/AccountStatusEventsTimelineTestIds'

export const accountStatusEventsTimelineHelp: HelpFile = {
  docPage: '/docs/admin/lifecycle-events',
  texts: {
    [AccountStatusEventsTimelineTestIds.accountStatusEventsTimeline]:
      'Vertical timeline of account status events for this account — newest first. Each row shows the status pair, trigger source, actor, timestamp, and reason.',
    [AccountStatusEventsTimelineTestIds.accountStatusFiltersPanel]:
      'Filter the timeline by trigger source and date range. Filters are collapsed by default — click "Filters" to expand.',
    [AccountStatusEventsTimelineTestIds.accountStatusTimelineEmpty]:
      'No account status events match the current filters. Use "Clear filters" to reset, or wait for new transitions to be recorded.',
    [AccountStatusEventsTimelineTestIds.accountStatusTimelineError]:
      'The timeline could not be loaded. Check the error log for details and retry.',
    [AccountStatusEventsTimelineTestIds.accountStatusTimelineLoading]: null,
    [AccountStatusEventsTimelineTestIds.accountStatusTimelineRows]:
      'Account status event rows — each row links to the trigger reference (job execution, access request, or originating identity event).',
    [AccountStatusEventsTimelineTestIds.accountStatusEventTriggerRefLink]:
      'Deep link to the trigger that caused this status change — opens the related job execution or access request.',
    [AccountStatusEventsTimelineTestIds.btnToggleAccountStatusFilters]:
      'Show or hide the filter panel for this timeline.',
    [AccountStatusEventsTimelineTestIds.btnClearAccountStatusFilters]:
      'Reset all filters on this timeline.',
    [AccountStatusEventsTimelineTestIds.inputAccountStatusFilterFrom]:
      'Lower bound of the date range — events with a changed_at before this value are hidden.',
    [AccountStatusEventsTimelineTestIds.inputAccountStatusFilterTo]:
      'Upper bound of the date range — events with a changed_at after this value are hidden.',
  },
}
